class StickySections {
  constructor(containerElement) {
    this.container = {
      el: containerElement,
      stickyEl: containerElement.children[0],
      innerEl: containerElement.children[0].children[0],
    };
    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    this.init();
  }

  onScroll(e) {
    this.handleSections();
  }

  onResize(e) {
    this.handleSectionPadding();
  }

  // Animate scroll
  handleSections() {
    const rectEl = this.container.el.getBoundingClientRect();
    const rectStickyEl = this.container.stickyEl.getBoundingClientRect();
    if (rectEl.top > 0) {
      //   this.container.stickyEl.style.marginLeft = 0;
      this.container.innerEl.style.transform = "translate3d(0px,0px,0px)";
    }
    if (rectEl.top <= 0 && rectEl.bottom >= 0) {
      let relPos = rectEl.top - rectStickyEl.top;
      //   this.container.stickyEl.style.marginLeft = relPos + "px";
      this.container.innerEl.style.transform =
        "translate3d(" + relPos + "px,0px,0px)";
    }
  }

  // Set Scroll-Container height
  // set scroll height
  handleSectionDimensions() {
    this.container.el.style.height =
      this.container.stickyEl.scrollWidth -
      window.innerWidth +
      window.innerHeight +
      "px";
  }

  // Set padding to align items
  // justify content in center
  handleSectionPadding() {
    const currentPaddingTop =
      "getComputedStyle" in window
        ? window.getComputedStyle(this.container.innerEl, null).paddingTop
        : 0;

    const padding =
      (window.innerHeight -
        this.container.innerEl.getBoundingClientRect().height +
        2 * parseFloat(currentPaddingTop)) /
      2;

    if (padding >= 0) {
      this.container.innerEl.style.paddingTop = padding + "px";
      this.container.innerEl.style.paddingBottom = padding + "px";
    }
  }

  init() {
    this.handleSectionDimensions();
    this.handleSectionPadding();
    this.handleSections();

    window.addEventListener("resize", this.onResize);
    // window.addEventListener("scroll", this.onScroll);
    document.addEventListener("scroll", this.onScroll);
  }
}

window.onload = function () {
  // Init StickySections
  const sectionsContainer = document.querySelectorAll(".mb-scrolling-area");
  sectionsContainer.forEach((section) => {
    new StickySections(section);
  });
};
